import { Directive, Renderer2, ElementRef, OnInit } from '@angular/core';
import { CommonService, SessionManagerService } from '../services';

@Directive({
  selector: '[appDynamicTabIndex]',
  standalone: true,
})
export class DynamicTabIndexDirective implements OnInit {
  private originalTabIndexMap = new Map<Element, string>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private readonly sessionManagerService: SessionManagerService,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {
    const originalTabIndex = this.el.nativeElement.getAttribute('tabindex') || '0';
    this.originalTabIndexMap.set(this.el.nativeElement, originalTabIndex);

    // Read the same preferences as the key handlers (cookie). The localStorage copy can be stale for
    // elements created after page load, e.g. the draw tool palette, which then lost its tabindex.
    let preferences = this.sessionManagerService.getUserPreferences();
    if (!preferences) {
      const preferences2: any = localStorage.getItem('preferences');
      if (preferences2 != 'undefined') {
        preferences = JSON.parse(preferences2);
      }
    }

    if (preferences) {
      this.updateTabIndex(preferences.isTabbingOn);
    }

    this.commonService.getIsTabbingOn().subscribe(data => {
      this.updateTabIndex(data);
    });
  }

  private updateTabIndex(isTabbingOn: boolean): void {
    if (isTabbingOn) {
      this.originalTabIndexMap.forEach((tabIndex, element) => {
        this.renderer.setAttribute(element, 'tabindex', tabIndex);
      });
    } else {
      this.originalTabIndexMap.forEach((tabIndex, element) => {
        // this.renderer.setAttribute(element, 'tabindex', '-1');
        this.renderer.removeAttribute(element, 'tabindex'); // Remove the tabindex
      });
    }
  }
}
